class headerMenuToggle {
    constructor() {
        const ID = {
            mainNavToggle: "main-nav",
            mainSiteNav: "main-site-nav",
            toggleIconBars: "main-site-nav-toggle-bars",
            toggleIconXmark: "main-site-nav-toggle-xmark"
        }
        const CLASSES = {
            active: "active",
            overflowHidden: "overflow-hidden",
            mobileActive: "site-header__mobile--active",
            hide: "d-none"
        }
        const ARIA = {
            hidden: "aria-hidden",
        }
        const ATTRIBUTES = {
            hide: "hidden",
        }

        const body = document.body;
        const mainNavToggle = document?.getElementById(ID.mainNavToggle);
        const mainSiteNav = document?.getElementById(ID.mainSiteNav);
        const toggleIconBars = document?.getElementById(ID.toggleIconBars);
        const toggleIconXmark = document?.getElementById(ID.toggleIconXmark);


        // Store the click handler as a property of the element
        const updateMenuDisplay = (menuToggle, nav, iconBars, iconXmark) => {

            if (menuToggle.classList.contains(CLASSES.active)) {
                addClass(iconXmark, CLASSES.hide);

                removeClass(menuToggle, CLASSES.active);
                removeClass(nav, CLASSES.mobileActive);
                removeClass(body, CLASSES.overflowHidden);
                removeClass(iconBars, CLASSES.hide);

                nav.setAttribute(ARIA.hidden, 'true');
                nav.setAttribute(ATTRIBUTES.hide, '');

            } else {
                addClass(menuToggle, CLASSES.active);
                addClass(nav, CLASSES.mobileActive);
                addClass(body, CLASSES.overflowHidden);
                addClass(iconBars, CLASSES.hide);
                
                removeClass(iconXmark, CLASSES.hide);

                nav.removeAttribute(ARIA.hidden);
                nav.removeAttribute(ATTRIBUTES.hide);
            }
        }

        const removeClass = (element, classname) => {
            element.classList.remove(classname);
        }

        const addClass = (element, classname) => {
            element.classList.add(classname);
        }

        const init = () => {
            if (mainNavToggle != null) {
                // Remove existing click handler if it exists
                if (mainNavToggle._clickHandler) {
                    mainNavToggle.removeEventListener('click', mainNavToggle._clickHandler);
                }

                // Create and store new click handler
                mainNavToggle._clickHandler = () => {
                    updateMenuDisplay(mainNavToggle, mainSiteNav, toggleIconBars, toggleIconXmark);
                };

                // Add the click handler
                mainNavToggle.addEventListener('click', mainNavToggle._clickHandler);
            }
        }

        init();
    }
}

export default headerMenuToggle;